import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CognitoUserDto } from '@clearing-hub/common';
import { UserService } from '../../../service/user.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AttributeType } from 'aws-sdk/clients/cognitoidentityserviceprovider';

@Component({
  selector: 'fxch-update-attributes',
  templateUrl: './update-attributes.component.html',
  styleUrls: ['./update-attributes.component.scss']
})
export class UpdateAttributesComponent implements OnInit {

  user: CognitoUserDto;
  form: FormGroup;
  enabledAttributes: Array<string>;
  onUpdate: EventEmitter<Array<AttributeType>> = new EventEmitter<Array<AttributeType>>();

  constructor(private readonly fb: FormBuilder,
              private readonly modalRef: BsModalRef,
              private readonly userService: UserService) {
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: new FormControl({value: this.user.email, disabled: true}),
      attributes: this.fb.group({
        ...this.user.attributes.reduce((acc, item) => { acc[item.Name] = new FormControl(item.Value); return acc; }, {})
      })
    });
  }

  update() {
    const command = {
      username: this.form.getRawValue().username,
      attributes: Object.keys(this.form.value.attributes).map(k => {
        return {
          Name: k,
          Value: this.form.value.attributes[k]
        }
      })
    }
    this.userService.updateUserAttributes(command).subscribe(() => {
      this.onUpdate.emit(Object.keys(this.form.value.attributes).map(k => {
        return {
          Name: k,
          Value: this.form.value.attributes[k]
        }
      }));
      this.modalRef.hide();
    });
  }

  close(): void {
    this.modalRef.hide();
  }

  hasAttribute(attributeName: string) {
    const attributes = this.form.get('attributes').value;
    return attributes[attributeName]!=null;
  }

  toggleAttribute(attributeName: string) {
    const attributes = this.form.get('attributes') as FormGroup;
    if (this.hasAttribute(attributeName)) {
      attributes.removeControl(attributeName);
    } else {
      attributes.addControl(attributeName, new FormControl('', [Validators.required, Validators.minLength(1)]));
      // TODO not neededed -> attribute can't removable, only can be modified
      // const existingProp = this.user.attributes.find(a => a.Name === attributeName);
      // attributes.addControl(attributeName, new FormControl(existingProp ? existingProp.Value : '', [Validators.required, Validators.minLength(1)]));
    }
  }

  onCheckClick(event, isChecked, a) {
    if (!isChecked && this.user.attributes.find(attr => attr.Name === a)) {
      event.preventDefault();
    }
    // console.log(isChecked);
    // if (!isChecked) {
    //   console.log('ASDQWE')
    //   event.preventDefault();
    // }
    // console.log(this.form.value.attributes[a])
    // if (!!this.form.value.attributes[a]) {
    //   console.log('ASDQWE')
    //   event.preventDefault();
    // }
    // event.preventDefault();
  }
}
